const initialState = {
    currentLang: { lang: 'en', id: 2 },
    userDetails: null,
};

export default initialState;
